import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTorchApplication } from '../../components/TorchApplicationContext'
import { ContinueDraft } from './ContinueDraft'
import { ExistingUserIndex } from './ExistingUserIndex'
import { FullFilm } from './FullFilms'
import { Page1Skeleton } from './Page1Skeleton'
import { ResubmitTorch } from './ResubmitTorch'
import { TorchTypeSelection } from './TorchTypeSelection'

const existingUserSteps = [ExistingUserIndex, ContinueDraft, TorchTypeSelection, ResubmitTorch, FullFilm]

export enum ExistingUserStep {
  Index,
  Continue,
  Type,
  Resubmission,
  Full,
}

export const Splash = () => {
  const { pathname, query, replace } = useSafeRouter()
  const { pageStepIndex, loading } = useTorchApplication()

  if (pageStepIndex === 0 && query.id) {
    delete query.id
    replace({ pathname, query }, undefined, { shallow: true })
  }

  if (loading) return <Page1Skeleton />

  const StepComponent = existingUserSteps[pageStepIndex]

  if (!StepComponent) {
    return null
  }

  return <StepComponent />
}
